const loaderScript = document.getElementById('nmvx-component-loader');

const moduleDefinitions = [
  ['product-sku-component', loaderScript?.dataset.productSku],
  ['product-inventory', loaderScript?.dataset.productInventory],
  ['media-gallery', loaderScript?.dataset.mediaGallery],
  ['volume-pricing', loaderScript?.dataset.volumePricing],
  ['price-per-item', loaderScript?.dataset.pricePerItem],
  ['volume-pricing-info', loaderScript?.dataset.volumePricingInfo],
].filter(([, url]) => Boolean(url));

const requestedModules = new Set();
let observer;

const rootContains = (root, selector) => {
  if (root instanceof Element && root.matches(selector)) return true;
  return typeof root?.querySelector === 'function' && Boolean(root.querySelector(selector));
};

const requestModule = (selector, url) => {
  if (requestedModules.has(selector)) return;

  requestedModules.add(selector);
  import(url).catch((error) => {
    requestedModules.delete(selector);
    console.warn(`[nmvx-component-loader] Could not load ${selector}:`, error);
  });
};

const scan = (root = document) => {
  moduleDefinitions.forEach(([selector, url]) => {
    if (!requestedModules.has(selector) && rootContains(root, selector)) {
      requestModule(selector, url);
    }
  });

  if (requestedModules.size === moduleDefinitions.length) {
    observer?.disconnect();
  }
};

scan(document);

if (requestedModules.size < moduleDefinitions.length) {
  observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) scan(node);
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
}

document.addEventListener('shopify:section:load', (event) => {
  scan(event.target);
});
